import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { m } from 'framer-motion';

import './ResetPassword';
import styles from './ResetPassword.module.scss';

import InputText from 'components/InputText/InputText';
import { Button } from 'components/Button/Button';
import { ArrowLeft, Mail } from 'components/Icons/Icons';
import { AnchorText } from 'components/AnchorText/AnchorText';
import { HorizontalDivider } from 'components/HorizontalDivider/HorizontalDivider';
import { requestPasswordReset } from 'utils/PointsAPI';
import { routes } from '../../routing/routes';

const ForgotPassword = () => {
  const [username, setUsername] = useState('');
  const [linkSent, setLinkSent] = useState(false);

  return (
    <div className="reset-password-container ">
      <m.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        className="password-reset"
      >
        <Helmet>
          <title>Forgot Password</title>
          <meta name="description" content="Forgot password?" />
        </Helmet>

        <section>
          <div className="container pt-5">
            <div className="row mx-sm-0 mx-1 justify-content-center">
              {!linkSent ? (
                <div className="col-xs-12 col-sm-7 pt-3">
                  <h2 className="text-center mb-2 mt-2">Forgot Password?</h2>
                  <p className="text-center">
                    Provide your email so we can send you reset instructions.
                  </p>

                  <HorizontalDivider />

                  <div className="mt-3 mb-4">
                    <InputText
                      id="email-input"
                      label="Email"
                      value={username}
                      onChange={(event) => {
                        setUsername(event.target.value);
                      }}
                      type="email"
                      placeholder="you@domain.com"
                    />
                  </div>

                  <div className="mb-3">
                    <Button
                      primary
                      fullWidth
                      onClick={async () => {
                        const result = await requestPasswordReset(username);
                        if (result) setLinkSent(true);
                        else alert('unable to send reset link');
                      }}
                    >
                      Reset password
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="col-xs-12 col-sm-7 pt-3">
                  <div className="col-12 mail-icon">
                    <Mail stroke={styles.mailIconColor} />
                  </div>

                  <h2 className="text-center mb-2 mt-2">Check your email</h2>
                  <p className="text-center">We sent a password reset link to {username}.</p>

                  <hr className="separator" />
                </div>
              )}
              <div className="text-center mb-4">
                <AnchorText href={routes.login()}>
                  <ArrowLeft stroke={styles.leftArrowColor} />
                  Back to Login
                </AnchorText>
              </div>
            </div>
          </div>
        </section>
      </m.main>
    </div>
  );
};

export default ForgotPassword;
